import { METALS } from "../constants";

const fmt = (n) =>
  n?.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
};

function Shimmer({ width = "100%", height = 20, radius = 6 }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background: "linear-gradient(90deg,#1e1e2a 25%,#2a2a3a 50%,#1e1e2a 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.4s infinite",
      }}
    />
  );
}

function MetalCard({ metal, data, loading, error, onPress }) {
  const isUp = data?.change >= 0;
  return (
    <div
      onClick={() => data && !loading && !error && onPress(metal, data)}
      className="metal-card"
      style={{
        background: `linear-gradient(135deg,${metal.bg} 0%,#0f0f18 100%)`,
        border: `1px solid ${metal.accent}22`,
        cursor: data && !loading && !error ? "pointer" : "default",
      }}
      onMouseEnter={(e) => {
        if (data && !loading) {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = `0 12px 40px ${metal.accent}30`;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <div className="glow" style={{ background: `${metal.accent}18` }} />
      <div className="card-header">
        <div>
          <div className="card-title-row">
            <span className="card-icon" style={{ color: metal.accent }}>
              {metal.icon}
            </span>
            <span className="card-name">{metal.name}</span>
            <span
              className="card-badge"
              style={{
                background: `${metal.accent}25`,
                color: metal.accent,
              }}
            >
              {metal.karat}
            </span>
          </div>
          <span className="card-symbol">{metal.symbol} · per troy oz</span>
        </div>
        {data && !loading && (
          <div
            className={`card-pct ${isUp ? "up" : "down"}`}
            style={{
              background: isUp ? "#4ade8018" : "#f8717118",
            }}
          >
            {isUp ? "▲" : "▼"} {Math.abs(data.changePct)}%
          </div>
        )}
      </div>
      {loading ? (
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <Shimmer height={36} radius={8} />
          <Shimmer width="60%" height={14} radius={6} />
        </div>
      ) : error ? (
        <div className="err" style={{ fontSize: 13 }}>
          ⚠ Failed to load
        </div>
      ) : data ? (
        <>
          <div
            className="card-price"
            style={{ color: metal.color }}
          >
            ${fmt(data.price)}
          </div>
          <div className="card-bottom">
            <span className={`card-change ${isUp ? "up" : "down"}`}>
              {isUp ? "+" : ""}
              {fmt(data.change)} USD
            </span>
            <span className="card-time">🕐 {fmtTime(data.timestamp)}</span>
          </div>
        </>
      ) : null}
    </div>
  );
}

/** Part 2: Market content – header, precious metals, footer */
export default function MarketDashboard({
  prices,
  loading,
  errors,
  onMetalPress,
  onRefresh,
  children,
}) {
  return (
    <main className="main-content">
      <div className="scroll-area">
        <header className="header">
          <div className="header-inner">
            <div>
              <div className="eyebrow">SIMPLIFY MONEY</div>
              <h1 className="page-title">Markets</h1>
              <p className="subtitle">Check LIVE prices of your luxury!</p>
            </div>
            <button className="refresh-btn" onClick={onRefresh}>
              ↻ Refresh
            </button>
          </div>
        </header>

        {children}

        <div className="divider" />

        <div className="metals-section">
          <div className="section-label">PRECIOUS METALS</div>
          <div className="metal-cards">
            {METALS.map((metal, i) => (
              <div
                key={metal.id}
                style={{
                  animation: `fadeUp 0.4s ease ${i * 0.07}s both`,
                }}
              >
                <MetalCard
                  metal={metal}
                  data={prices[metal.id]}
                  loading={loading[metal.id]}
                  error={errors[metal.id]}
                  onPress={onMetalPress}
                />
              </div>
            ))}
          </div>
        </div>

        <p className="footer-note">
          Live prices · GoldAPI.io &amp; ExchangeRate-API
        </p>
      </div>
    </main>
  );
}
